import { useSampleFlaskPrepsStore } from "@/store/modules/sampleFlaskPrep";
import InstallationChildren from "@/router/atmo/projects/project/installations/installation/children";

const InstallationsList = () =>
  import(
    /* webpackChunkName: "InstallationsList" */ "@/components/atmo/projects/project/installations/InstallationsList.vue"
  );

const Installation = () =>
  import(
    /* webpackChunkName: "Installation" */ "@/components/atmo/projects/project/installations/Installation.vue"
  );

export default [
  {
    path: "",
    name: "project-installations",
    component: InstallationsList,
  },
  {
    path: ":installationUuid",
    component: Installation,
    children: InstallationChildren,
    meta: { subNavs: "installation" },
    beforeEnter: async (to, from, next) => {
      if (to.params.installationUuid !== from.params.installationUuid) {
        // setInstallationFlaskPreps
        await useSampleFlaskPrepsStore()
          .setInstallationFlaskPreps(to.params.installationUuid)
          .catch((err) => {
            console.error("Error setting installation flask preps:", err);
          });
      }
      next();
    },
  },
];
